<div class="header">
  <div>
    <span *ngIf="iconType === IconType.Default"
          class="circle-icon">{{config?.defaultIconNumber}}</span>
    <mat-icon *ngIf="iconType === IconType.Changes"
              class="circle-icon circle-icon--changes">edit</mat-icon>
    <mat-icon *ngIf="iconType === IconType.Warning"
              class="material-icons-round warning-icon">warning</mat-icon>
  </div>
  <div class="header__text">
    <div class="title title--warning"
         [ngClass]="{ 'title--warning': iconType === IconType.Warning}">
      {{config?.title}}
      <mat-icon *ngIf="sectionBlockedData?.isBlocked"
                [matTooltip]="sectionBlockedData?.reason"
                class="material-icons-round blocked-icon"
                [ngClass]="{'blocked-icon--in-progress': sectionBlockedData?.isUnblockingInProgress}">warning</mat-icon>
    </div>
    <span *ngIf="iconType === IconType.Warning"
          class="subtitle subtitle--warning">{{config?.warningSubtitle}}</span>
  </div>
</div>
